import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Plugin from '@jbrowse/core/Plugin';
import { getFileName } from '@jbrowse/core/util/tracks';
// locals
import WiggleBaseRenderer from './WiggleBaseRenderer';
import WiggleRendering from './WiggleRendering';
import BigWigAdapterF from './BigWigAdapter';
import QuantitativeTrackF from './QuantitativeTrack';
import MultiQuantitativeTrackF from './MultiQuantitativeTrack';
import MultiWiggleAdapterF from './MultiWiggleAdapter';
import DensityRendererF from './DensityRenderer';
import XYPlotRendererF from './XYPlotRenderer';
import LinePlotRendererF from './LinePlotRenderer';
import LinearWiggleDisplayF from './LinearWiggleDisplay';
import MultiLinearWiggleDisplayF from './MultiLinearWiggleDisplay';
import MultiXYPlotRendererF from './MultiXYPlotRenderer';
import MultiRowXYPlotRendererF from './MultiRowXYPlotRenderer';
import MultiDensityRendererF from './MultiDensityRenderer';
import MultiLineRendererF from './MultiLineRenderer';
import MultiRowLineRendererF from './MultiRowLineRenderer';
import CreateMultiWiggleExtensionF from './CreateMultiWiggleExtension';
import MultiWiggleAddTrackWidgetF from './MultiWiggleAddTrackWidget';
import * as utils from './util';
import { WiggleGetGlobalStats, WiggleGetMultiRegionStats, MultiWiggleGetSources } from './WiggleRPC/rpcMethods';
import { ReactComponent as LinearWiggleDisplayReactComponent, modelFactory as linearWiggleDisplayModelFactory, Tooltip } from './LinearWiggleDisplay';
import { ReactComponent as XYPlotRendererReactComponent, configSchema as xyPlotRendererConfigSchema, XYPlotRenderer } from './XYPlotRenderer';
var WigglePlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(WigglePlugin, _Plugin);
  function WigglePlugin() {
    var _this;
    _classCallCheck(this, WigglePlugin);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(WigglePlugin).apply(this, arguments));
    _this.name = 'WigglePlugin';
    _this.exports = {
      LinearWiggleDisplayReactComponent: LinearWiggleDisplayReactComponent,
      XYPlotRendererReactComponent: XYPlotRendererReactComponent,
      XYPlotRenderer: XYPlotRenderer,
      WiggleBaseRenderer: WiggleBaseRenderer,
      linearWiggleDisplayModelFactory: linearWiggleDisplayModelFactory,
      xyPlotRendererConfigSchema: xyPlotRendererConfigSchema,
      utils: utils
    };
    return _this;
  }
  _createClass(WigglePlugin, [{
    key: "install",
    value: function install(pm) {
      MultiWiggleAdapterF(pm);
      BigWigAdapterF(pm);
      QuantitativeTrackF(pm);
      MultiQuantitativeTrackF(pm);
      LinearWiggleDisplayF(pm);
      MultiLinearWiggleDisplayF(pm);
      LinePlotRendererF(pm);
      XYPlotRendererF(pm);
      DensityRendererF(pm);
      MultiXYPlotRendererF(pm);
      MultiRowXYPlotRendererF(pm);
      MultiDensityRendererF(pm);
      MultiLineRendererF(pm);
      MultiRowLineRendererF(pm);
      MultiWiggleAddTrackWidgetF(pm);
      CreateMultiWiggleExtensionF(pm);
      pm.addToExtensionPoint('Core-guessAdapterForLocation', function (cb) {
        return function (file, index, hint) {
          var regexGuess = /\.(bw|bigwig)$/i;
          var adapterName = 'BigWigAdapter';
          var fileName = getFileName(file);
          var obj = {
            type: adapterName,
            bigWigLocation: file
          };
          if (regexGuess.test(fileName) && !hint) {
            return obj;
          } else if (hint === adapterName) {
            return obj;
          }
          return cb(file, index, hint);
        };
      });
      pm.addToExtensionPoint('Core-guessTrackTypeForLocation', function (trackTypeGuesser) {
        return function (adapterName) {
          if (adapterName === 'BigWigAdapter') {
            return 'QuantitativeTrack';
          }
          return trackTypeGuesser(adapterName);
        };
      });
      pm.addRpcMethod(function () {
        return new WiggleGetGlobalStats(pm);
      });
      pm.addRpcMethod(function () {
        return new WiggleGetMultiRegionStats(pm);
      });
      pm.addRpcMethod(function () {
        return new MultiWiggleGetSources(pm);
      });
    }
  }]);
  return WigglePlugin;
}(Plugin);
export { WigglePlugin as default };
export * from './util';
export { LinearWiggleDisplayReactComponent, Tooltip, WiggleRendering, WiggleBaseRenderer, linearWiggleDisplayModelFactory };